import { useMediaQuery, Theme } from "@material-ui/core";
import { Breakpoint } from "@material-ui/core/styles/createBreakpoints";

export const useSizeCheck = (size: Breakpoint) =>
  useMediaQuery((theme: Theme) => theme.breakpoints.down(size));
